import "../extensions/htmlelement";
import "../extensions/object";
export class Form {
    static inputs(form) {
        let rsubmittable = /^(?:input|select|textarea|keygen)/i;
        let elements = form.getElementsByTagName("*");
        let inputs = [];
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let valid = element.getAttribute("name") && rsubmittable.test(element.nodeName);
            if (valid) {
                inputs.push(element);
            }
        }
        return inputs;
    }
    static serializeObject(form, includeData) {
        let output = {};
        includeData = includeData || false;
        let rCRLF = /\r?\n/g, rMultipleType = /^(?:checkbox)$/i, rcheckableType = /^(?:checkbox|radio)$/i;
        let inputs = this.inputs(form);
        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            let name = input.getAttribute("name");
            let data = input.getData();
            let type = input.nodeName.toLowerCase();
            let val = "";
            let checked;
            switch (type) {
                case "input":
                    type = input.getAttribute("type").toLowerCase();
                    val = input.value;
                    checked = input.checked;
                    break;
                case "textarea":
                    val = input.value;
                    break;
                case "select":
                    val = input.value;
                    break;
            }
            val = val.replace(rCRLF, "\r\n");
            let obj;
            if (includeData && !Object.isEmpty(data)) {
                obj = { value: val };
                obj = Object.merge(obj, data);
            }
            else {
                obj = val;
            }
            if (!rcheckableType.test(type)) {
                output[name] = obj;
            }
            else if (checked) {
                if (rMultipleType.test(type)) {
                    output[name] = Array.isArray(output[name]) ? output[name] : [];
                    output[name].push(obj);
                }
                else {
                    output[name] = obj;
                }
            }
        }
        ;
        return output;
    }
}
